<template>
    <div class="border rounded-10 overflow-hidden cursor-pointer font-main bg-white box-shadow" @click="clickCampaign()">
        <Picture :campaign="campaign"></Picture>
        <div class="px-2 pt-2 pb-2.5">
            <div class="campaign-name mb-2.5 h-6 font-medium text-10 text-a-black-484848">{{campaign.name}}</div>
            <div class="font-light text-10 text-a-gray-afafaf">{{getExpireDate()}}</div>
        </div>
    </div>
</template>
<script>
// mixins
import LocaleMixin from "@/mixin/LocaleMixin.js";
// helper
import DatetimeHelper from "@/helper/DatetimeHelper";
//components
import Picture from "./Picture.vue";
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    components: {
        Picture,
    },
    props: {
        campaign: { type: Object, required: true },
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    created: function() {
        this.tracking.event("privilege_page_list", "view_privilege_list", this.campaign.id + "|" + this.campaign.name, "");
    },
    methods: {
        getPointMessage: function () {
            let pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            let pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        getExpireDate: function(){
            return this.lbl.campaign.expired_on +' '+ DatetimeHelper.getDatetimeFullByFormat(this.campaign.expireDate, 'dd MMMM yyyy');
        },

        clickCampaign: function() {
            this.tracking.event("privilege_page_list", "click_privilege_list", this.campaign.id + "|" + this.campaign.name, "");
            this.$router.push('/campaign/' + this.campaign.id);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    @import "@/style/base/text.scss";
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
    .campaign-name{
        @extend %ellipsis-2;
    }
    .box-shadow{
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }
</style>
